import { PATIENT_DOCUMENT } from "../constants";

const initialState = {
  documents: [],
  isLoadingGet: false,
  isLoadingUpload: false,
  error: null,
};

const patientDocumentReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PATIENT_DOCUMENT.GET_DOCUMENTS:
      return { ...state, isLoadingGet: true };
    case PATIENT_DOCUMENT.GET_DOCUMENTS_SUCCESS:
      return { ...state, isLoadingGet: false, documents: action.payload, error: null };
    case PATIENT_DOCUMENT.GET_DOCUMENTS_FAILURE:
      return { ...state, isLoadingGet: false, error: action.payload };
    case PATIENT_DOCUMENT.UPLOAD_DOCUMENT:
      return { ...state, isLoadingUpload: true };
    case PATIENT_DOCUMENT.UPLOAD_DOCUMENT_SUCCESS:
      return { ...state, isLoadingUpload: false, error: null };
    case PATIENT_DOCUMENT.UPLOAD_DOCUMENT_FAILURE:
      return { ...state, isLoadingUpload: false, error: action.payload };
    case PATIENT_DOCUMENT.DELETE_DOCUMENT_SUCCESS:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default patientDocumentReducer;
